import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Pro = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M13.872 10.778a.5.5 0 0 1-.485-.622l1.566-6.22c.2-.796-.786-1.342-1.354-.748l-8.305 8.681a.8.8 0 0 0 .578 1.353h4.256a.5.5 0 0 1 .485.622l-1.566 6.22c-.2.796.786 1.342 1.354.748l8.305-8.681a.8.8 0 0 0-.578-1.353z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    ) : (
      <path
        d='M13.872 10.778a.5.5 0 0 1-.485-.622l1.566-6.22c.2-.796-.786-1.342-1.354-.748l-8.305 8.681a.8.8 0 0 0 .578 1.353h4.256a.5.5 0 0 1 .485.622l-1.566 6.22c-.2.796.786 1.342 1.354.748l8.305-8.681a.8.8 0 0 0-.578-1.353z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
